<div id="seitenanordnung" class="example-container info" *ngIf="mandant">
  <div id="hauptcontent">
    <div id="vertrag">
      <web-registrierung-kopf *ngIf="vertrag_methode != 1"></web-registrierung-kopf>
      <div id='vertrag-text' class="contentblock" [innerHTML]="vertrags_text"></div>
    </div>
  </div>
</div>
